// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
export { default } from '/vercel/path0/theme-default/builtins/Container/index.js';
